<template>
  <div>
      <div class="mt-4 position-relative">
          <div class="mb-5 one-user-card">
              <div class="user-card" style="box-shadow: none;">
                  <b-form-checkbox 
                    v-model="show_fired" 
                    :id="`show_fired_${departmentId}`" 
                    :name="`show_fired_${departmentId}`" 
                    switch
                >
                      <b>Показывать уволенных</b>
                  </b-form-checkbox>
              </div>
              <div class="user-analytic"></div>
          </div>
          <div 
              v-if="!dataOverlay"
              class="mb-5 one-user-card"
              v-for="(user, u_index) in filteredAnalytic"
          >
              <div class="user-card">
                  <h6>{{ user.name }}</h6>
                  <div class="font-weight-bold">{{ user.position }}</div>
                  <div>{{ user.fired==0 ? 'Работает' : 'Уволен' }}</div>
                  <small>Карточка создана: <br>{{ user.created_at }}</small>
              </div>
              <div class="user-analytic">
                  <h6 class="text-center">Компании, привязанные к менеджеру</h6>
                  <div class="user-analytic-companies mt-4">
                      <div
                      v-for="(element, index) in user.analytic.companies"
                      :title="element.name"
                      :key="index"
                      @click="changeOpenedCompanyType(index)"
                      class="analytic-type"
                      :style="(numbers_are_opened && index==company_opened) ? 'color: #EA7B27' : ''"
                      >
                      <div class="text-center" v-if="!dataOverlay">
                          <span class="bigNumber">{{ element.sum }}</span>
                          <div>{{ element.name }}</div>
                      </div>
                      <div class="font-size-14" v-if="dataOverlay"><b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" class="mr-2" animation="spin"></b-icon>Обновляем...</div>
                      </div>
                  </div>
                  <hr>
                  <div class="mt-3" v-if="numbers_are_opened && user.analytic.companies && user.analytic.companies[company_opened] && user.analytic.companies[company_opened].list.length > 0">
                      <h6>Компании в списке:</h6>
                      <div
                      v-for="(company, c_index) in user.analytic.companies[company_opened].list"
                      >
                      {{ c_index + 1 }}: <span class="sidebar-link" @click="openCompanySidebar(company.id)">{{ company.name }}</span> / {{ company.inn }}
                      </div>
                  </div>
              </div>
          </div>
                    
          <b-overlay
              :show="dataOverlay"
              spinner-variant="success"
              no-wrap
          ></b-overlay>
      </div>
  </div>
</template>

<script>
  import { API_USER_ANALYTIC_BY_DEPARTMENT } from "@/constants"
  import { openCompanySidebar } from '@/mixins/openCompanySidebar';

  export default {
      props: {
        departmentId: {
            type: Number,
            require: true
        }
      },    
      mixins: [
          openCompanySidebar
      ],
      data() {
          return {
              dataOverlay: true,
              analytic: [],
              company_opened: '',
              numbers_are_opened: false,
              show_fired: false,
          }
      },
      watch: {
        departmentId: {
            immediate: true,
            handler(value) {
                this.fetchAnalytic(value);
            },
        },         
      },
      computed: {
          filteredAnalytic() {
              if (this.analytic.length > 0) {
                  if (!this.show_fired) {
                      return this.analytic.filter(user => user.fired !== 1);
                  } else {
                      return this.analytic;
                  }
              }

              return [];
          }
      },
      methods: {
          fetchAnalytic(department_id) {
              this.dataOverlay = true;

              axios.get(`${API_USER_ANALYTIC_BY_DEPARTMENT}/${department_id}`).then(({ data }) => {
                  this.analytic = data;
                  this.analytic.sort((a, b) => a.name.localeCompare(b.name));
                  this.dataOverlay = false;
              });       
          },
          changeOpenedCompanyType(key_name) {
              if (key_name != this.company_opened || this.numbers_are_opened == false) {
                  this.company_opened = key_name;
                  this.numbers_are_opened = true;
              } else {
                  this.numbers_are_opened = false;
              }
          }
      }
  }
</script>
<style scoped>
    .one-user-card {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;    
    }
    .user-card {
        width: 300px;
        text-align: center;
        background: #fff;
        padding: 12px;
        box-shadow: 0px 10px 5px 0px rgba(0,0,0,0.05);
        -webkit-box-shadow: 0px 10px 5px 0px rgba(0,0,0,0.05);
        -moz-box-shadow: 0px 10px 5px 0px rgba(0,0,0,0.05);        
    }
    .user-analytic {
        width: 100%;
        padding-left: 25px;
    }
    .user-analytic-companies {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-around;
        align-items: center;
        align-content: center;
    }
    .analytic-type {
        cursor:pointer;
    }
</style>